/**
 * Attachments (Phase-1 reference §10). Staff answer support questions by pasting a
 * screenshot far more often than by describing what they see, so the limits and the
 * behaviour are ported as they were.
 *
 * Only images reach the model. PDFs and text files are stored with the question so
 * the human answering it can open them — being explicit about that is the point: an
 * assistant that silently ignores an attached PDF looks like one that read it.
 */

export const ATTACHMENT_MAX_BYTES = 8 * 1024 * 1024;
export const ATTACHMENT_MAX_COUNT = 5;

/** Accepted content types: any image, PDF, or plain text. */
export const ATTACHMENT_ACCEPT = "image/*,.pdf,.txt";

export interface AttachmentUpload {
  name: string;
  /** `data:<mime>;base64,<payload>` — the shape a browser FileReader produces. */
  dataUrl: string;
}

export interface Attachment {
  /** Stored filename, and the path segment of its download URL. */
  id: string;
  name: string;
  contentType: string;
  bytes: number;
  /** False for PDFs and text: stored with the question, never read by the model. */
  readByModel: boolean;
}

export const isImageAttachment = (contentType: string): boolean => contentType.startsWith("image/");

/** Verbatim Phase-1 copy — the note appended when attachments rode along. */
export const ATTACHMENT_SAVED_NOTE = "Märkus: lisatud manus(ed) salvestati küsimuse juurde.";
